<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label>Tipo de conta</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="bank"
              value="bank"
            />
            <label class="form-check-label" for="bank">Conta bancário</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              v-model="type"
              class="form-check-input"
              type="radio"
              name="type"
              id="other"
              value="other"
            />
            <label class="form-check-label" for="other">Outra</label>
          </div>
        </div>
      </div>
      <div v-if="type == 'bank'" class="col-md-8">
        <label>Banco</label>
        <treeselect
          :multiple="false"
          :options="[{ id: '', label: 'SELECIONE...', children: [] }, ...banks]"
          placeholder="SELECIONE..."
          v-model="bank_id"
          noChildrenText="NÃO POSSUI BANCO(S) FILHO(S)"
        />
      </div>
      <div v-if="type == 'bank'" class="col-md-4">
        <label>Tipo</label>
        <select v-model="account_type" class="form-control">
          <option value="CORRENTE">CORRENTE</option>
          <option value="POUPANCA">POUPANÇA</option>
        </select>
      </div>
      <div v-if="type == 'bank'" class="col-md-3">
        <label>Agência</label>
        <input type="text" class="form-control" v-model="agency" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3">
        <label>Conta</label>
        <input type="text" class="form-control" v-model="account" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3">
        <label>- DV</label>
        <input type="text" class="form-control" v-model="account_dv" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3">
        <label>Convênio</label>
        <input type="text" class="form-control" v-model="agreement" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3">
        <label>Gerente</label>
        <input type="text" class="form-control" v-model="manager" />
      </div>
      <div v-if="type == 'bank'" class="col-md-3">
        <label>Telefone</label>
        <input type="text" class="form-control" v-model="telephone" />
      </div>
      <div class="col-md-6">
        <LabelRequiredField label="Apelido da conta" />
        <input type="text" class="form-control" v-model="account_nickname" />
      </div>
      <div class="col-md-3">
        <LabelRequiredField label="Data de início" />
        <input type="date" class="form-control" v-model="start_date" />
      </div>
      <div class="col-md-3">
        <LabelRequiredField label="Saldo nesta data" />
        <input
          type="text"
          class="form-control"
          v-model="balance_date"
          @input="handleInputBalanceDate($event.target.value)"
        />
      </div>
      <div class="col-md-6">
        <label>Situação da conta</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              v-model="account_status"
              class="form-check-input"
              type="radio"
              name="account_status"
              id="negative"
              value="0"
            />
            <label
              class="form-check-label v-danger p-1 pl-2 pr-2 noBorderRadius"
              for="negative"
              >Negativo</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              v-model="account_status"
              class="form-check-input"
              type="radio"
              name="account_status"
              id="positive"
              value="1"
            />
            <label
              class="form-check-label v-success p-1 pl-2 pr-2 noBorderRadius"
              for="positive"
              >Positivo</label
            >
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label>Agrupamento</label>
        <select v-model="grouping_id" class="form-control">
          <option v-for="(item, key) in groupings" :value="item.id" :key="key">
            {{ item.description }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="allows_releases"
            id="allows_releases"
          />
          <label class="form-check-label" for="allows_releases">
            Permite lançamento(s)
          </label>
        </div>
        <small
          >Contas que NÃO permitem lançamentos podem apenas receber créditos e
          débitos através de Transferências.</small
        >
      </div>
      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" @click="create" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import Treeselect from "@riophae/vue-treeselect";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import moment from "moment";

import { formatDecimal, formatValueOnKeyUp } from "../../../../lib/format";

export default {
  name: "Create",
  components: {
    ErrorsMessages,
    LabelRequiredField,
    Treeselect,
  },
  props: {
    groupings: Array,
    banks: Array,
  },
  data() {
    return {
      bank_id: "",
      account_type: "",
      type: "bank",
      agency: "",
      account: "",
      account_dv: "",
      agreement: "",
      manager: "",
      telephone: "",
      account_nickname: "",
      start_date: moment().format("YYYY-MM-DD"),
      balance_date: "",
      account_status: 1,
      grouping_id: "",
      allows_releases: "",
      loading: false,
      errors: [],
      penalty_type: 0,
      penalty_value: "",
      interest_type: 3,
      interest_value: "",
      discount_type: 0,
      discount_value: "",
      protest_type: 3,
      protest_days: 0,
      downpayment_type: 1,
      downpayment_days: 0,
    };
  },
  methods: {
    formatValueOnKeyUp,
    formatDecimal,
    handleInputBalanceDate(balance_date) {
      this.balance_date = formatValueOnKeyUp(balance_date);
    },
    handleInputValue(value, key) {
      this[key] = formatValueOnKeyUp(value);
    },
    async create() {
      try {
        this.loading = true;

        const {
          bank_id,
          account_type,
          type,
          agency,
          account,
          account_dv,
          agreement,
          manager,
          telephone,
          account_nickname,
          start_date,
          balance_date,
          account_status,
          grouping_id,
          allows_releases,
          penalty_type,
          penalty_value,
          interest_type,
          interest_value,
          discount_type,
          discount_value,
          protest_type,
          protest_days,
          downpayment_type,
          downpayment_days,
        } = this;

        let params = {
          bank_id,
          account_type,
          type,
          agency,
          account,
          account_dv,
          agreement,
          manager,
          telephone,
          account_nickname,
          start_date,
          balance_date,
          account_status,
          grouping_id,
          allows_releases,
          penalty_type,
          penalty_value,
          interest_type,
          interest_value,
          discount_type,
          discount_value,
          protest_type,
          protest_days,
          downpayment_type,
          downpayment_days,
        };

        const response = await api.post(
          "/rest-home/financial/configuration/account",
          params
        );

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide("create");

          this.$emit("success", id);

          this.bank_id = "";
          this.account_type = "";
          this.agency = "";
          this.account = "";
          this.account_dv = "";
          this.agreement = "";
          this.manager = "";
          this.telephone = "";
          this.account_nickname = "";
          this.start_date = "";
          this.balance_date = "";
          this.grouping_id = "";
          this.penalty_type = 0;
          this.penalty_value = "";
          this.interest_type = 3;
          this.interest_value = "";
          this.discount_type = 0;
          this.discount_value = "";
          this.protest_type = 3;
          this.protest_days = 0;
          this.downpayment_type = 1;
          this.downpayment_days = 0;

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
